// extracted by mini-css-extract-plugin
module.exports = {"reparse":"DebugButtons_reparse__2uVrr"};